export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./HomePage.vue?vue&type=template&id=6c774b02&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/HomePage.vue?vue&type=template&id=6c774b02&scoped=true&
// module id = 578
// module chunks = 0